import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import sentaraLogoWhite from "../../../assets/tenant-logos/sentara-logo-white.png";
import { useGetTenantConfig } from "../hooks/useGetTenantConfig";
import { getTenantKey } from "@/lib/room-context";

/** Designed logo box (Figma 20174:42437 instance). The mark is letterboxed inside it. */
const LOGO_BOX = { width: 173, height: 36 } as const;

type Props = {
  tenantLogo?: string;
  tenantName?: string;
  /** Show the "Return to TV" hint only while the ElevenLabs session is live. */
  agentConnected?: boolean;
};

export function HeaderWithLogo({
  tenantLogo = sentaraLogoWhite,
  tenantName = "Sentara",
  agentConnected = false,
}: Props = {}) {
  const tenantKey = getTenantKey();
  const view = useGetTenantConfig(tenantKey);
  return (
    <Box
      component="header"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        px: "24px",
        pt: "16px",
        pb: "17px",
        borderBottom: "1px solid rgba(255, 255, 255, 0.07)",
      }}
    >
      <Box sx={{ ...LOGO_BOX, flexShrink: 0 }}>
        <Box
          component="img"
          src={view.view?.LOGO_LIGHT || tenantLogo}
          alt={`${tenantName} logo`}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            pointerEvents: "none",
          }}
        />
      </Box>

      {agentConnected ? (
        <Box
          sx={{
            flexShrink: 0,
            bgcolor: "rgba(255, 255, 255, 0.06)",
            border: "1px solid rgba(255, 255, 255, 0.14)",
            borderRadius: "14px",
            px: "18px",
            py: "10px",
          }}
        >
          <Typography
            component="p"
            sx={{
              fontFamily: "var(--font-sans)",
              fontWeight: 500,
              fontSize: "13px",
              lineHeight: "19.5px",
              letterSpacing: "0.13px",
              textAlign: "center",
              whiteSpace: "nowrap",
              color: "rgba(255, 255, 255, 0.5)",
            }}
          >
            Say{" "}
            <Box component="span" sx={{ color: "rgba(255, 255, 255, 0.92)" }}>
              {'"Return to TV"'}
            </Box>
          </Typography>
        </Box>
      ) : (
        <Box sx={{ flexShrink: 0 }} aria-hidden />
      )}
    </Box>
  );
}
